import { datadogLogs } from '@datadog/browser-logs';

export const sendAnalytic = (eventName: string, id: string, companyId: string, type = '') => {
  datadogLogs.logger.info(eventName, {
    name: eventName,
    orderId: id,
    companyId: companyId,
    type: type,
  });
};
